import {
  Avatar, Button, CircularProgress, Divider, Fab, Tab, Tabs, Tooltip,
  Typography, MenuItem, Select, TextField, IconButton, InputAdornment, Paper, Grid, useTheme, Autocomplete,
  FormControl, Dialog, DialogActions, DialogContent, DialogTitle,
  InputLabel, Modal
} from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import MemberDetails from "./memberDetails";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton } from "@mui/x-data-grid";
import SucceedCheck from "../../components/common/LotteStyles/succeedCheck.json";
import Drawer from "../../components/common/drawer/drawer";
import { TABS, ROLES, DATE_FORMATS } from "../../constants";
import moment from "moment";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { AuthContext } from "../../components/contextAPI/ContextAPI";
import {
  Add, AddAPhoto, AddTask, SaveAlt, SaveAltOutlined, SaveAs, ManageSearch, MobileFriendly, MobileOff,
  Edit, LocationCity, MonetizationOn, Search
} from "@mui/icons-material";
import Lottie from "lottie-react";
import DeletionReasonModal from "../../components/modals/deletionReasonModal";
import { useNavigate } from "react-router-dom";
import UserModal from "../../components/modals/userModal";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import BulkUploadTargetUser from "../../components/modals/bulkUploadTargetUser";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import axios from "axios";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import searchIcon from "../../icons/searchIcon.svg"

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
      `}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "56px - 20px - 82.23px" : "100px - 20px - 43.77px"}
  // );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;




const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  // height: 548px;
  width: 100%;
  // border: solid 1px lightGrey;
  display: ${isMobile ? "flex" : "grid"};
  border-radius: 8px;

  ${isMobile &&
  `
    flex-direction: column;
  `}
`;

const LoadingContainer = styled.div`
  height: calc(100% - 49px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TabsContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#ffffff',
  padding: '8px 16px',
  borderRadius: '12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  marginBottom: '20px',
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderRadius: '8px',
  '& .MuiTabs-indicator': {

    height: '3px',
    borderRadius: '3px',
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '15px',
  color: '#555',
  textTransform: 'none',
  '&.Mui-selected': {
    color: "#d6e0f5",
  },
}));


const UserManagement = (props) => {

  const navigation = useNavigate();
  const [userModal, setUserModal] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [rejectData, setRejectData] = useState(null);
  const [reason, setReason] = useState("");
  const [staffMembers, setStaffMembers] = useState([]);
  const [visibleEmployees, setVisibleEmployees] = useState([]);
  const [reasonModalObj, setReasonModalObj] = useState({});
  const [selectedMember, setSelectedMember] = useState(null);
  const [LocalStoredData, setLocalStoredData] = useState({})
  const [search, setSearch] = useState("")
  const [clusters, setClusters] = useState([])
  const [selectedRole, setSelectedRole] = useState("")
  const [selectedTab, setSelectedTab] = useState(TABS.REGISTERED);
  const [showReplacementPicker, setShowReplacementPicker] = useState(false);
  const [selectedCluster, setSelectedCluster] = useState("")
  const [showDeletionReasonPicker, setShowDeletionReasonPicker] =
    useState(false);
  const [showBulkUploadPicker, setShowBulkUploadPicker] = useState(false);
  const [showBulkUserDeleteModal, setShowBulkUserDeleteModal] = useState(false);
  const [bulkTargetUpload, setBulkTargetUpload] = useState(false);
  const [loading, setLoading] = useState(false);
  const { auth, setAuth } = useContext(AuthContext);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({
    page: currentPage - 1,
    pageSize: 20,
  });
  const [roleId, setRoleId] = useState([])
  const [rowCount, setRowCount] = useState();
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [hasSearched, setHasSearched] = useState(false);
  const [userViewModal, setUserViewModal] = useState(false);
  const [userViewData, setUserViewData] = useState([]);
  const [accessModulesData, setAccessModulesData] = useState([]);
const [releaseDialog, setReleaseDialog] = useState({
    open: false,
    userId: null,
    remark: "",
    remarkError: "",
    submitting: false,
});
  useEffect(() => {
    setLoading(true);
    const storedUserData = JSON.parse(localStorage.getItem("storedUserData"));
    setLocalStoredData(storedUserData)
    if (hasSearched) {

      if (storedUserData?.user) {
        if (storedUserData.user.role.toLowerCase().includes('admin')) {
          if (selectedTab == 1) {
            fetchEmployees(storedUserData, 2)
          }
          else if (selectedTab == 2) {
            fetchEmployees(storedUserData, 1)
          }
          else {
            fetchEmployees(storedUserData)
          }
        }
        else {
          // fetchEmployees(storedUserData)
          if (selectedTab == 1) {
            fetchEmployees(storedUserData, 2)
          }
          else if (selectedTab == 2) {
            fetchEmployees(storedUserData, 1)
          }
          else {
            fetchEmployees(storedUserData)
          }
        }
      }
    }
  }, [paginationModel.page, paginationModel.pageSize]);

  const openReleaseDialog = (userId) => {
    setReleaseDialog({ open: true, userId, remark: "", remarkError: "", submitting: false });
};

const closeReleaseDialog = () => {
    setReleaseDialog({ open: false, userId: null, remark: "", remarkError: "", submitting: false });
};

const handleReleaseRemarkChange = (e) => {
    const val = e.target.value;
    setReleaseDialog((prev) => ({
        ...prev,
        remark: val,
        remarkError:
            val.trim().replace(/\s+/g, " ").length < 20
                ? `Remark must be at least 20 characters (${val.trim().replace(/\s+/g, " ").length}/20)`
                : "",
    }));
};

const handleReleaseConfirm = async () => {
    const trimmed = releaseDialog.remark.trim().replace(/\s+/g, " ");
    if (!trimmed) {
        setReleaseDialog((p) => ({ ...p, remarkError: "Remark is required" }));
        return;
    }
    if (trimmed.length < 20) {
        setReleaseDialog((p) => ({ ...p, remarkError: `Remark must be at least 20 characters (${trimmed.length}/20)` }));
        return;
    }
    try {
        setReleaseDialog((p) => ({ ...p, submitting: true }));
        let results = await window.Platform.database.releaseDeviceId({
            userId: releaseDialog.userId,
            release_remark: trimmed,               // ← new payload key
        });
        if (results?.status) {
            window.NotificationUtils.showSuccess(results?.message || "Device ID has been released");
            closeReleaseDialog();
            fetchEmployees(LocalStoredData);
        } else {
            window.NotificationUtils.showError(results?.message || "Error releasing Device ID");
            setReleaseDialog((p) => ({ ...p, submitting: false }));
        }
    } catch (error) {
        console.error(error);
        window.NotificationUtils.showError("Something went wrong");
        setReleaseDialog((p) => ({ ...p, submitting: false }));
    }
};

  const fetchOrder = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        userId: userData?.id,
        moduleId: "QYR2xOlu3d"
      }
      let results = await window.Platform.database.fetchAccessModules(data);
      if (results?.status) {
        window.NotificationUtils.showError(results?.message || "Something went wrong");
        setLoading(false);
        return;
      }
      else {
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
        setAccessModulesData(jsonArrayWithId);
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    fetchOrder();
    setLoading(true);
    getClusterInPicklist()
    fetchRoles()
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])


  const fetchRoles = async (details) => {
    try {
      setLoading(true)
      // console.log("PLANTCODE",plantcode[0].plant_code__c)
      let results = await window.Platform.database.fetchRoles(details);
      // console.log("PRODUCT RESULTS: ", results.data.map((data) => data.roleName))
      if (results?.status) {
        setLoading(false);
        window.NotificationUtils.showError("Something went wrong");
      }
      else {
        setRoleId(results.data)
        setLoading(false)
      }
      // setProduct(results.data)
    }
    catch (err) {
      console.log(err);
      setLoading(false)

    }
  }

  const findUsers = async () => {
    setLoading(true);
    const storedUserData = JSON.parse(localStorage.getItem("storedUserData"));
    setLocalStoredData(storedUserData)

    if (storedUserData?.user) {
      if (storedUserData.user.role.toLowerCase().includes('admin')) {
        if (selectedTab == 1) {
          fetchEmployees(storedUserData, 2)
        }
        else if (selectedTab == 2) {
          fetchEmployees(storedUserData, 1)
        }
        else {
          fetchEmployees(storedUserData)
        }
      }
      else {
        // fetchEmployees(storedUserData)
        if (selectedTab == 1) {
          fetchEmployees(storedUserData, 2)
        }
        else if (selectedTab == 2) {
          fetchEmployees(storedUserData, 1)
        }
        else {
          fetchEmployees(storedUserData)
        }
      }
    }
  }

  const handleDelete = (data) => {
    console.log(data, "skdbkjasbkjadsbasjdbasjbdkasjbasdjkb")
    setRejectData(data);
    setOpenDialog(true);
  };

  const handleConfirmReject = () => {
    const cleanedRemark = reason.trim().replace(/\s+/g, " ");
    if (!cleanedRemark) {
      window.NotificationUtils.showError("Remark is required.");
      return;
    }
    if (cleanedRemark.length < 20) {
      window.NotificationUtils.showError("Remark must be at least 20 characters long.");
      return;
    }
    approveRejectOrder({ reason: cleanedRemark });
    setOpenDialog(false);
    setReason("");
    setRejectData(null);
  };

  // const suspendUser = async (data1) => {
  //    const confirmDelete = window.confirm(
  //      `Are you sure you want to Suspend ${data1.name}  (${data1.username})?`,
  //   );
  //   if (!confirmDelete) return;

  //   try {
  //     setLoading(true)
  //     let results = await window.Platform.database.suspendedUser({id: data1.id });
  //     window.NotificationUtils.showSuccess(results?.message || "User Suspend successfully")
  //     setLoading(false)
  //     onClose()
  //   }
  //   catch (err) {
  //     console.log(err)
  //     window.NotificationUtils.showError("User Suspension Failed")
  //     setLoading(false)
  //   }
  // };

  const approveRejectOrder = async (val) => {
    try {
      setLoading(true);
      // if (selectedTab == 0) {
      const payload = {
        id: rejectData?.id,
        action_remark: reason
      }
      // const response = await window.Platform.database.deleteSchool(payload);

      // window.NotificationUtils.showSuccess(response?.message || "Success");
      // console.log(payload,"payload paudihkjbkjs ");
      // return;
      try {
        // let results = await window.Platform.database.suspendedUser({id: data1.id });
        let results = await window.Platform.database.suspendedUser(payload);
        window.NotificationUtils.showSuccess(results?.message || "User Suspend successfully")
        setLoading(false)
        onClose()
      }
      catch (err) {
        console.log(err)
        window.NotificationUtils.showError("User Suspension Failed")
        setLoading(false)
      }

      // }
      // else {
      //   const payload = {
      //     id: rejectData,
      //     status: newOrderStatus1 == "1" ? 0 : 1,
      //     action_remark: reason
      //   }
      //   const response = await window.Platform.database.deleteDistributor(payload);

      //   window.NotificationUtils.showSuccess(response?.message || "Success");

      // }
    } catch (error) {
      console.error("Error inactive School:", error);
      window.NotificationUtils.showError("Error Found");
    } finally {
      setLoading(false);
    }
  }


  async function getAllUsers() {
    setLoading(true);
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      setLoading(false);
    }
  }

  async function getUsers(role, id) {
    setLoading(true);
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (results?.status) {
        window.NotificationUtils.showError("Something went wrong");
        setLoading(false);
        return;
      }
      else {
        if (role == 'rsm') {
          setAsms(results?.data)
          setRms(results?.data1)
          setLoading(false);
        }
        if (role == 'asm') {
          setRms(results?.data)
          setLoading(false);
        }
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
        setLoading(false);
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setLoading(false);
      }
    }
  }

  const onClose = () => {
    setUserModal(null);
    handleTabChange(TABS.REGISTERED);
  };

  const discardModal = () => {
    setUserModal(null);
  };

  let contextState = { ...auth };
  var disableScroll = false;
  const isManager = [
    ROLES.SERVICE_MANAGER,
    ROLES.SALES_MANAGER_ENGAGEMENT,
  ].includes(auth?.user.role);

  const getEmployeeName = (employeeCode) => {
    let result = "";
    let member = staffMembers.find(
      (member) => member.employeeCode === employeeCode
    );
    if (member) {
      result = `${member.firstName} ${member.lastName ? member.lastName : ""}`;
    } else {
      member = visibleEmployees.find(
        (member) => member.employeeCode === employeeCode
      );
      if (member) {
        result = `${member.firstName} ${member.lastName ? member.lastName : ""
          }`;
      }
    }
    return result;
  };
  const resetDeviceId = async (val) => {
    try {
      setLoading(true);
      let results = await window.Platform.database.resetDeviceId(val);
      window.NotificationUtils.showSuccess("Device ID has been reset");
      fetchEmployees(LocalStoredData);
      setLoading(false);
    } catch (error) {
      console.error(error);

      window.NotificationUtils.showError("Error Fetching Employees");

      setLoading(false);
    }
  };

  const handleViewUser = async (rowData) => {
    setLoading(true);
    try {
      let result = await window.Platform.database.getUsersForView(rowData?.id);
      if (result?.status === false && result?.data) {
        setUserViewData(result.data);
        setUserViewModal(true);
        setLoading(false);
      } else {
        window.NotificationUtils.showError(result?.message || "Error fetching visit details");
        setLoading(false);
      }
    } catch (error) {
      window.NotificationUtils.showError("Error fetching visit details");
      setLoading(false);
    }
    // finally {
    //   setLoading(false);
    // }
  };

  const handleCloseUserViewModal = () => {
    setUserViewModal(false);
    setUserViewData([]);
  };

  const releaseDeviceID = async (val) => {
    const isSuccess = window.confirm("Are you sure you want to release this user's device ID ?");
    if (!isSuccess) return;
    try {
      setLoading(true);
      let results = await window.Platform.database.releaseDeviceId({ userId: val });
      if (results?.status) {
        window.NotificationUtils.showSuccess(results?.message || "Device ID has been released");
        fetchEmployees(LocalStoredData);
        setLoading(false);
      }
      else {
        window.NotificationUtils.showError(results?.message || "Error releasing Device ID");
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Something went wrong");
      setLoading(false);
    }
  };

  const employeeColumns = () => {
    var results = [
      {
        field: "name",
        headerName: "Name",
        minWidth: 160,
        sortable: false,
        valueGetter: (params) => {
          let name = params.row.name || "N/A";
          return name.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" ");
        },
        renderCell: (params) => {
          let name = params.row.name.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" ") || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "email",
        headerName: "Email",
        minWidth: 230,
        sortable: false,
        valueGetter: (params) => {
          return params.row.email || "N/A";
        },
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.email || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row.email || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "username",
        headerName: "User Name",
        minWidth: 110,
        sortable: false,
        valueGetter: (params) => {
          return params.row.username || "N/A";
        },
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.username || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row.username || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "mobile",
        headerName: "Mobile",
        minWidth: 110,
        sortable: false,
        valueGetter: (params) => {
          return params.row.mobno || "N/A";
        },
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.mobno || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row.mobno || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "role",
        headerName: "Role",
        minWidth: 220,
        sortable: false,
        // valueGetter: (params) => {
        //   if (!params.row.role) return "N/A";
        //   if (params.row.role.toLowerCase() === "se") {
        //     return "RM";
        //   }
        //   if (params.row.role.toLowerCase() === "asm") {
        //     return "ARM";
        //   }
        //   if (params.row.role.toLowerCase() === "rsm") {
        //     return "HO";
        //   }
        //   if (params.row.role.toLowerCase() === "zsm") {
        //     return "National Head";
        //   }

        //   return params.row.role
        //     .split(" ")
        //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        //     .join(" ");
        // },
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.role_name?.toUpperCase() || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row.role_name?.toUpperCase() || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "createdAt",
        headerName: "Created On",
        minWidth: 100,
        sortable: false,
        valueGetter: (params) => {
          if (!params.row.createdAt) return "N/A";
          const date = new Date(params.row.createdAt);
          return date.toLocaleDateString("en-GB"); // formats as DD/MM/YYYY
        },
        renderCell: (params) => {
          const dateValue = params.row.createdAt
            ? new Date(params.row.createdAt).toLocaleDateString("en-GB") // DD/MM/YYYY
            : "N/A";

          return (
            <Tooltip title={dateValue}>
              <Typography
                variant="inherit"
                sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}
              >
                {dateValue}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 100,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleViewUser(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={userViewModal} onClose={handleCloseUserViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" style={{ textAlign: "center" }} sx={{ color: "black", fontSize: "16px", fontWeight: "600" }}>
                    User Details
                  </Typography>
                  <IconButton onClick={() => setUserViewModal(false)} style={{ position: "absolute", top: 10, right: 10 }}>
                    <CloseOutlined />
                  </IconButton>
                  <hr style={{ width: "100%", border: "none", borderTop: "2px solid #222", margin: "16px 0" }} />
                  <div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Name: </b> <span >{userViewData[0]?.name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b> User Name :</b> {userViewData[0]?.username || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>Reporting Manager : </b> {userViewData[0]?.reportingManagerName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Assigned Role : </b> {userViewData[0]?.role_name || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Actual Role :</b> {userViewData[0]?.actual_role || "N/A"}

                      </div>
                      <div className="col-md-6">
                        <b>Email : </b> {userViewData[0]?.email || "N/A"}

                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Mobile Number : </b> {userViewData[0]?.mobno || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Reporting Manager : </b> {userViewData[0]?.reportingManagerName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Created On : </b> {new Date(userViewData[0]?.createdAt).toLocaleDateString("en-GB") || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Eligible For DA :</b> {userViewData[0]?.eligible_for_DA || "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-12">
                        <b>Address : </b> {userViewData[0]?.AddressLine1 + ", " + userViewData[0]?.AddressLine2 || "N/A"}
                        {/* <b>Reporting Manager : </b> {userViewData[0]?.reportingManagerName || "N/A"} */}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>  Area : </b> {userViewData[0]?.areaNames || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>City : </b> {userViewData[0]?.city || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>  Area : </b> {userViewData[0]?.clusterName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Pincode : </b> {userViewData[0]?.Pincode || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>District : </b> {userViewData[0]?.District || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>State : </b> {userViewData[0]?.State || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-12">
                        <b> Base Address : </b> {userViewData[0]?.baseAddress || "N/A"}
                      </div>
                    </div>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseUserViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
      // {
      //   field: "DOJ",
      //   headerName: "Date Of Joining",
      //   minWidth: 130,
      //   flex: 0.22,
      //   sortable: false,
      //   valueGetter: (params) => {
      //     return params.row.dob || "N/A";
      //   },
      //   renderCell: (params) => {
      //     const timestamp = params.row?.dob ? Number(params.row.dob) * 1000 : null;

      //     if (!timestamp || isNaN(timestamp)) return "N/A";

      //     const formattedDate = new Date(timestamp).toLocaleDateString("en-IN", {
      //       year: "numeric",
      //       month: "long",
      //       day: "numeric",
      //       timeZone: "Asia/Kolkata",
      //     });

      //     return (
      //       <Tooltip title={formattedDate}>
      //         <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{formattedDate}</Typography>
      //       </Tooltip>
      //     );
      //   },
      // },
      {
        field: "actionByName1",
        headerName: "Action Taken By",
        minWidth: 150,
        // flex: 0.35,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.actionByName || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {params.row.actionByName || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "action_remark",
        headerName: "Action Remark",
        minWidth: 200,
        // flex: 0.35,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.action_remark || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {params.row.action_remark || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: `${!selectedTab ? "editUser" : "viewUser"}`,
        headerName: `${accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no" ? (!selectedTab ? "Edit" : "View") : (!selectedTab ? "" : "View")}`,
        width: 80,
        headerAlign: "center",
        align: "center",
        sortable: false,
        filterable: false,
        disableExport: true,
        renderCell: (params) => {
          return (
            <Tooltip
              title={
                !selectedTab ? "Click to edit details" : "Click to view details"
              }
            >
              <IconButton
                size="large"
                variant="extended"
                color="primary"
                onClick={() => {
                  setUserModal(params.row);
                }}
              >
                {!selectedTab ? accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no" && (
                  <Edit fontSize="inherit" />
                ) : (
                  <RemoveRedEyeIcon fontSize="inherit" />
                )}
              </IconButton>
            </Tooltip>
          );
        },
      },
      selectedTab == 0 && {
        field: "suspend11",
        headerName: "Suspend User",
        minWidth: 200,
        sortable: false,
        renderCell: (params) => {
          return (
            <Tooltip>
              <span>
                <Button
                  variant="contained"
                  size="small"
                  // onClick={() => suspendUser(params.row)}
                  onClick={(e) => handleDelete(params.row, e)}
                  sx={{ minWidth: "80px" }}
                >
                  Suspend
                </Button>
              </span>
            </Tooltip>
          )
        },
      },
      ((userData?.role == "super admin") && selectedTab == 0) && {
        field: "releaseDeviceId1",
        headerName: "Release Device ID",
        minWidth: 200,
        sortable: false,
        renderCell: (params) => {
          return (
            <Tooltip>
              <span>
                <Button
                  disabled={params?.row?.device_id == null || params?.row?.device_id == undefined || params?.row?.device_id == ""}
                  variant="contained"
                  size="small"
                  // onClick={() => suspendUser(params.row)}
                  onClick={(e) => openReleaseDialog(params.row?.id)}
                  sx={{ minWidth: "80px" }}
                >
                  Release Device ID
                </Button>
              </span>
            </Tooltip>
          )
        },
      },
    ];
    return results;
  };

  var deletedColumns = [
    {
      field: "firstName",
      headerName: "Name",
      minWidth: 200,
      valueGetter: (params) => {
        let name = getEmployeeName(params.row.employeeCode);
        return name;
      },
      flex: 0.22,
      sortable: false,
      renderCell: (params) => {
        let name = getEmployeeName(params.row.employeeCode);
        return (
          <Tooltip title={name || "N/A"}>
            <Typography variant="inherit">{name}</Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 250,
      flex: 0.35,
      sortable: false,
      valueGetter: (params) => {
        return params.row.previousEmail || "";
      },
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.previousEmail || "N/A"}>
            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
              {params.row.previousEmail}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "role",
      headerName: "Role",
      minWidth: 150,
      flex: 0.22,
      sortable: false,
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.role || "N/A"}>
            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{params.row.role || "N/A"}</Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "deletionReason",
      headerName: "De-Activation reason",
      minWidth: 250,
      flex: 0.35,
      sortable: false,
      valueGetter: (params) => {
        let name = params.row.deletionReason;
        if (name == null || name.length == 0) name = "No reason provided";
        return name;
      },
      renderCell: (params) => {
        let name = params.row.deletionReason;
        if (name == null || name.length == 0) name = "No reason provided";
        return (
          <Tooltip title={name || "N/A"}>
            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
          </Tooltip>
        );
      },
    },
    // {
    //   field: "terminationDate",
    //   headerName: "Date of leaving",
    //   minWidth: 250,
    //   flex: 0.35,
    //   sortable: false,
    //   valueGetter: (params) => {
    //     let name = moment.unix(params.row.terminationDate).format("MM/DD/YYYY");
    //     if (name == "Invalid date") name = "Termination date not provided";
    //     return name;
    //   },
    //   renderCell: (params) => {
    //     let name = moment.unix(params.row.terminationDate).format("MM/DD/YYYY");
    //     if (name == "Invalid date") name = "Termination date not provided";
    //     return (
    //       <Tooltip title={name || "N/A"}>
    //         <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
    //       </Tooltip>
    //     );
    //   },

    //   renderCell: (params) => {
    //     let name = moment.unix(params.row.terminationDate).format("MM/DD/YYYY");
    //     return (
    //       <Tooltip title={name || "N/A"}>
    //         <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
    //       </Tooltip>
    //     );
    //   },
    // },
  ];

  const handleTabChange = async (value, keepSelected = false) => {
    setVisibleEmployees([]);
    if (!keepSelected) {
      setSelectedMember(null);
    }
    setSelectedTab(value);
    setVisibleEmployees([]);
    setRsm("");
    setAsm("");
    setRm("");
    setSearch("")
    setSelectedRole("")
    setSelectedCluster("")
    setDebouncedSearch("")
    // if (value === TABS.REGISTERED) {
    //   await fetchEmployees(LocalStoredData);
    // } else {
    //   await fetchEmployees(LocalStoredData, 1);
    // }
  };

  const addNewMember = () => {
    setUserModal(true);
    setSelectedMember({});

    if (isMobile) {
      scrollToPreview();
    }
  };

  // const suspendUser = async (data1) => {
  //    const confirmDelete = window.confirm(
  //      `Are you sure you want to Suspend ${data1.name}  (${data1.username})?`,
  //   );
  //   if (!confirmDelete) return;

  //   try {
  //     setLoading(true)
  //     let results = await window.Platform.database.suspendedUser({id: data1.id });
  //     window.NotificationUtils.showSuccess(results?.message || "User Suspend successfully")
  //     setLoading(false)
  //     onClose()
  //   }
  //   catch (err) {
  //     console.log(err)
  //     window.NotificationUtils.showError("User Suspension Failed")
  //     setLoading(false)
  //   }
  // };

  const exportUsers = async () => {
    setLoading(true);
    try {
      let data = {
        role: selectedRole,
        cluster: selectedCluster,
        search: search,
        status: selectedTab === 0 ? "" : selectedTab == 1 ? 2 : 1
      };

      let result = await window.Platform.database.exportData("/user/exportUsers",
        data
      )
      // Check if the response is actually a Blob
      console.log(result.data, "API Response Data");

      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "users.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  };

  const onClickBulkUpload = () => {
    try {
      if (selectedTab !== TABS.PENDING) {
        handleTabChange(TABS.PENDING);
      }

      setShowBulkUploadPicker(true);
    } catch (error) {
      console.error(error);
    }
  };

  const onClickDeleteEmployee = async (reportingManager = "") => {
    try {
      let data = { ...selectedMember };
      data = { ...data, warehouse: data.warehouse?.id };
      let { reason, terminationDate } = reasonModalObj;
      console.log(data);
      await window.Platform.database.deleteEmployee(data, {
        reason,
        terminationDate,
      });
      if (selectedTab === TABS.PENDING) {
        let index = visibleEmployees.findIndex(
          (member) => member.id === data.id
        );
        let newMembers = [...visibleEmployees];
        newMembers.splice(index, 1);
        setVisibleEmployees(newMembers);
        setSelectedMember(null);
      } else {
        if (showDeletionReasonPicker) {
          setShowDeletionReasonPicker(false);
        }
        await handleTabChange(TABS.REGISTERED);
      }
      window.NotificationUtils.showSuccess("Successfully deleted employee");
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const setReasonModalData = (name, value) => {
    try {
      setReasonModalObj({ ...reasonModalObj, [name]: value });
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const deletedUsers = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.deletedUsers();
      setVisibleEmployees(results);
      setLoading(false);
    } catch (error) {
      console.error(error);

      window.NotificationUtils.showError("Error Fetching Employees");

      setLoading(false);
    }
  };

  const fetchPendingEmployees = async () => {
    try {
      setLoading(true);

      let results = await window.Platform.database.fetchPendingEmployees();

      setVisibleEmployees(results);

      setLoading(false);
    } catch (error) {
      console.error(error);

      window.NotificationUtils.showError("Error Fetching Employees");

      setLoading(false);
    }
  };




  const uploadTarget = async () => {
    setBulkTargetUpload(true);
  };
  const getClusterInPicklist = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getClusterInPicklist();

      const jsonArrayWithId = results?.data?.map((obj) => ({
        ...obj,
        dbId: obj.id
      }));


      setClusters(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      setLoading(false);
    }
  };

  const fetchEmployees = async (data, status) => {
    setLoading(true);
    let results;
    try {
      if (Object.keys(data).length) {
        setLoading(true);

        if (userData.role.toLowerCase().includes('admin')) {
          results = await window.Platform.database.getUsersWeb(status, selectedRole, selectedCluster, search, paginationModel.page, paginationModel.pageSize, rm, rsm, asm);
        } else {
          results = await window.Platform.database.getUsersBasedOnManager({ userId: data.user.id });
        }

        if (results.status) {
          setLoading(false);
          window.NotificationUtils.showError(results.message);
        } else {
          setStaffMembers(results.data);
          setRowCount(results?.data1);
          setVisibleEmployees(results.data);
          setLoading(false);
        }
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Employees");
      setLoading(false);
    }
  };


  const scrollToPreview = () => {
    window.scrollTo(
      0,
      document.getElementById("detailsPreviewContainer").getBoundingClientRect()
        .top
    );
  };

  const renderLoading = () => {
    return <OpaqueLoading />;
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {/* <GridToolbarColumnsButton /> */}
      </GridToolbarContainer>
    );
  }

  const renderTabContent = () => {
    if (loading) {
      return renderLoading();
    }

    return (
      <>
        <div className="d-flex justify-content-end align-items-center  py-2">
          <Typography variant="body1" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Page Size :&nbsp; </Typography>
          <Select
            value={paginationModel.pageSize}
            variant="outlined"
            size="small"
            onChange={(e) => { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
            sx={{ width: 90, fontSize: 14, fontWeight: "500" }}
          >
            {[10, 20, 30, 50, 100].map((role) => (
              <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role}</MenuItem>
            ))}
          </Select>
        </div>
        <DataGridContainer
          style={{ height: !visibleEmployees.length ? "200px" : "auto" }}
        >
          <DataGrid
            className="payrollGrid"
            density="compact"
            rows={visibleEmployees || []}
            columns={employeeColumns()}
            disableSelectionOnClick
            disableRowSelectionOnClick
            rowHeight={60}
            sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
            rowCount={rowCount}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            paginationMode="server"
            // initialState={{
            //   pagination: {
            //     paginationModel: {
            //       pageSize: 10,
            //     },
            //   },
            // }}
            // pageSizeOptions={[10]}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>
      </>
    );
  };

  const deleteConfirmationModal = () => {
    setShowBulkUserDeleteModal(true);
  };

  return (
    <>
      <StaffEditorPageContainer>
        <HeaderContainer>
          {userModal && (
            <UserModal
              user={auth.user}
              onClose={onClose}
              discardModal={discardModal}
              data={userModal}
              allusers={visibleEmployees}
              selectedTab={selectedTab}
            />
          )}
          {/* <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            </div> */}

          <Box sx={{ mt: 1, width: "100%" }}>
            {LocalStoredData?.user?.role.toLowerCase().includes("admin") && (
              <Paper elevation={3}
                sx={{
                  p: 2,
                  mb: 2,
                  width: '100%',        // takes full width of parent
                  // maxWidth: '1000px',   // optional: control max width
                  mx: 'auto',
                  backgroundColor: "#ebf0fa"          // center it horizontally
                }}>
                <div className="row mb-2">
                  {/* {userData?.role.includes('admin') && <div className="col-md-3">
                            <Typography variant="body1">Select HO:</Typography>
                            <Select value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                              <MenuItem value="">All</MenuItem>
                              {rsms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
                            </Select>
                          </div>} */}
                  {userData?.role.includes('admin') && (
                    <div className="col-md-3">
                      <Autocomplete
                        options={rsms}
                        // getOptionLabel={(option) => option.name || ""}
                        getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                        value={rsms.find((role) => role.id === rsm) || null}
                        onChange={(event, value) => {
                          setRsm(value ? value.id : "");
                          setAsm("");
                          setRm("");
                          getUsers('rsm', value ? value.id : "");
                        }}
                        renderInput={(params) => (
                          <TextField
                            label="Select HO"
                            fullWidth
                            {...params}
                            // variant="outlined"
                            size="small"
                            placeholder="Select HO"
                            InputProps={{
                              ...params.InputProps,
                              style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                            }}
                            InputLabelProps={{
                              style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                            }}
                          />
                        )}
                        slotProps={{
                          paper: {
                            sx: { color: "black" }
                          }
                        }}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        sx={{ width: '100%', fontSize: 14 }}
                      />
                    </div>
                  )}
                  {/* {userData?.role != 'asm' && <div className="col-md-3">
                            <Typography variant="body1">Select ARM:</Typography>
                            <Select value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                              <MenuItem value="">All</MenuItem>
                              {asms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
                            </Select>
                          </div>} */}
                  {userData?.role !== 'asm' && (
                    <div className="col-md-3">
                      <Autocomplete
                        options={asms}
                        // getOptionLabel={(option) => option.name || ""}
                        getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                        value={asms.find((role) => role.id === asm) || null}
                        onChange={(event, value) => {
                          setAsm(value ? value.id : "");
                          setRm("");
                          getUsers('asm', value ? value.id : "");
                        }}
                        renderInput={(params) => (
                          <TextField
                            label="Select ARM"
                            {...params}
                            // variant="outlined"
                            size="small"
                            placeholder="Select ARM"
                            InputProps={{
                              ...params.InputProps,
                              style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                            }}
                            InputLabelProps={{
                              style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                            }}
                          />
                        )}
                        slotProps={{
                          paper: {
                            sx: { color: "black" }
                          }
                        }}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        sx={{ width: '100%', fontSize: 14 }}
                      />
                    </div>
                  )}
                  {/* <div className="col-md-2">
                            <Typography variant="body1">Select RM :</Typography>
                            <Select value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); getUsers('rm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                              <MenuItem value="">All</MenuItem>
                              {rms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
                            </Select>
                          </div> */}
                  <div className="col-md-3">
                    <Autocomplete
                      options={rms}
                      // getOptionLabel={(option) => option.name || ""}
                      getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                      value={rms.find((role) => role.id === rm) || null}
                      onChange={(event, value) => {
                        setRm(value ? value.id : "");
                        // getUsers('rm', value ? value.id : "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          label="Select RM"
                          {...params}
                          // variant="outlined"
                          size="small"
                          placeholder="Select RM"
                          InputProps={{
                            ...params.InputProps,
                            style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                          }}
                          InputLabelProps={{
                            style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                          }}
                        />
                      )}
                      slotProps={{
                        paper: {
                          sx: { color: "black" }
                        }
                      }}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      sx={{ width: '100%', fontSize: 14, color: "black" }}
                    />
                  </div>
                  {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-3">
                    <Button
                      onClick={exportUsers}
                      fullWidth
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                      color="success"

                      sx={{ height: 35, borderRadius: 2 }}
                    >
                      Download
                    </Button>
                  </div>}
                </div>
                <Grid container spacing={2} alignItems="center" flexWrap="wrap">
                  <Grid item xs={12} sm={4} md={3} >
                    <FormControl size="small" fullWidth>
                      <TextField
                        sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}
                        fullWidth
                        size="small"
                        placeholder="Type To Search"
                        label="Enter Name, Username, Email, Mobile No."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>
                              <Search color="action" sx={{ fontWeight: "500", color: "black", fontSize: "14px" }} />
                            </InputAdornment>
                          ),
                          style: { color: "black", fontSize: "16px", color: "black" },
                        }}
                        InputLabelProps={{
                          style: { color: "black", fontSize: "16px", color: "black" }, // Label color
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>
                        Select Role
                      </InputLabel>
                      <Select
                        label="Select Role"
                        fullWidth
                        sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}
                        value={selectedRole}
                        onChange={(e) => setSelectedRole(e.target.value)}
                      // variant="outlined"
                      // size="small"
                      >
                        <MenuItem value="" sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>All</MenuItem>
                        {roleId.map((role) => (
                          <MenuItem key={role.roleName} value={role.roleName} sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>
                            {role.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>
                        Select Area
                      </InputLabel>
                      <Select
                        label="Select Area"
                        fullWidth
                        value={selectedCluster}
                        sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}
                        onChange={(e) => setSelectedCluster(e.target.value)}
                      // variant="outlined"
                      // size="small"
                      >
                        <MenuItem value="" sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>All</MenuItem>
                        {clusters.map((role) => (
                          <MenuItem key={role.id} value={role.id} sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>
                            {role.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setHasSearched(true); findUsers() }}>
                      Find
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            )}
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  background: "#e8f5e9",
                  border: "1px solid #a5d6a7",
                  borderLeft: "4px solid #2e7d32",
                  borderRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                  width: "fit-content",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#1b5e20",
                    letterSpacing: "0.3px",
                  }}
                >
                  Total Entries:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 700,
                    color: "#2e7d32",
                    background: "#fff",
                    px: 1.2,
                    py: 0.2,
                    borderRadius: "6px",
                    border: "1px solid #a5d6a7",
                    minWidth: "28px",
                    textAlign: "center",
                  }}
                >
                  {visibleEmployees?.length > 0 ? rowCount : 0 || 0}
                </Typography>
              </Box>
              {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" &&
                <Box gap={2} display={"flex"}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={uploadTarget}
                    startIcon={<DriveFolderUploadIcon />}
                    sx={{ height: 30, borderRadius: 2 }}
                  >
                    Bulk Add Users
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={addNewMember}
                    startIcon={<Add />}
                    sx={{ height: 30, borderRadius: 2 }}
                  >
                    Add New
                  </Button>
                </Box>}
            </Box>
          </Box>
        </HeaderContainer>
        <TableContainer>
          <TabsContainer>
            <StyledTabs
              value={selectedTab}
              onChange={(event, value) => handleTabChange(value)}
              variant="fullWidth"
              indicatorColor="none"

            >
              <StyledTab label="Active" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: selectedTab == 0 ? "#fff" : "#e6e3e3de " }} />
              <StyledTab label="Suspended" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: selectedTab == 1 ? "#fff" : "#e6e3e3de " }} />
              <StyledTab label="Inactive" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: selectedTab == 2 ? "#fff" : "#e6e3e3de " }} />
            </StyledTabs>

            {renderTabContent()}
          </TabsContainer>
        </TableContainer>
      </StaffEditorPageContainer>
      {showDeletionReasonPicker && (
        <DeletionReasonModal
          selectedMember={selectedMember}
          data={reasonModalObj}
          setData={setReasonModalData}
          staffMembers={staffMembers}
          closeModal={() => setShowDeletionReasonPicker(false)}
          onClickDeleteEmployee={onClickDeleteEmployee}
        />
      )}
      {bulkTargetUpload && (
        <BulkUploadTargetUser
          onClose={() => setBulkTargetUpload(false)}
          fetchData={() => fetchEmployees(LocalStoredData)}
          allData={visibleEmployees}
        />
      )}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>Suspend User</DialogTitle>
        <DialogContent>
          User Name :- {rejectData ? rejectData.name + " - " + rejectData.username : "N/A"}
          <TextField autoFocus margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmReject} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={releaseDialog.open} onClose={!releaseDialog.submitting ? closeReleaseDialog : undefined} fullWidth maxWidth="sm">
    <DialogTitle>
        Release Device ID
        <IconButton
            onClick={closeReleaseDialog}
            disabled={releaseDialog.submitting}
            sx={{ position: "absolute", right: 10, top: 10 }}
        >
            <CloseOutlined />
        </IconButton>
    </DialogTitle>
    <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
            Please provide a remark for releasing this device ID. Remark must be at least 20 characters.
        </Typography>
        <TextField
            autoFocus
            fullWidth
            multiline
            minRows={3}
            margin="dense"
            label="Remark *"
            placeholder="Enter remark here..."
            variant="outlined"
            value={releaseDialog.remark}
            onChange={handleReleaseRemarkChange}
            error={!!releaseDialog.remarkError}
            helperText={releaseDialog.remarkError}
            disabled={releaseDialog.submitting}
        />
    </DialogContent>
    <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <Button onClick={closeReleaseDialog} disabled={releaseDialog.submitting} color="primary" variant="outlined">
            Cancel
        </Button>
        <Button
            onClick={handleReleaseConfirm}
            color="primary"
            variant="contained"
            disabled={releaseDialog.submitting}
            startIcon={releaseDialog.submitting ? <CircularProgress size={16} color="inherit" /> : null}
        >
            {releaseDialog.submitting ? "Releasing..." : "Confirm Release"}
        </Button>
    </DialogActions>
</Dialog>

    </>
  );
};

export default UserManagement;
